export default __webpack_public_path__ + "static/combination-of-different-series-types-371ab7de18085ea046fcf09bf1c79260.png";